import { mui, React, ts } from '_core';

type RiskStyleFactorsProps = {
  value: ts.types.widgets.common.BucketValue;
  setValue: (_v: ts.types.widgets.common.BucketValue) => void;
};

const RiskStyleFactors = ({ value, setValue }: RiskStyleFactorsProps) => {
  return (
    <>
      <mui.core.Grid size={{ xs: 12, md: 6 }}>
        <mui.core.TextField
          label="Quantiles (1 - 20)"
          variant="outlined"
          size="small"
          value={value.value}
          InputProps={{ inputProps: { min: 1, max: 20 } }}
          onChange={(e) => setValue({ ...value, value: e.target.value })}
          fullWidth
          required
        />
      </mui.core.Grid>
    </>
  );
};

export default RiskStyleFactors;
